module.exports = __webpack_public_path__ + "static/media/spirit-point-management.4f176c96.png";